import React from "react";
import "./login-page.scss";
import HOC from "../../../hoc";
import getUserManager from "../../../authentication/user-manager";
import { ReactComponent as Logo } from "../logo.svg";
import { useHref } from "react-router-dom";

const { withLocalization } = HOC;

const LoginPage = props => {
    const { loc } = props;
    const base = useHref("/");
    const onLoginButtonClick = e => {
        const userManager = getUserManager();
        e.preventDefault();
        const path = window.location.pathname;
        let url = "/";
        if (path !== "/login") {
            let redirectUrl = window.location.pathname + window.location.search;
            if (redirectUrl.startsWith(base)) redirectUrl = redirectUrl.replace(base, "/");
        }
        userManager.signinRedirect({ state: { redirectUrl: url } });
    };

    return (
        <div className="login-page ecg-report-component">
            <div className="login-page__logo-container">
                <Logo />
            </div>
            <h1 className="login-page__header">{loc("pages.login.header")}</h1>
            <div className="login-page__auth-header">{loc("pages.login.trigger")}</div>
            <div className="login-page__auth-controls">
                <button type="button" className="auth-controls__sign-in-btn button button-ok" onClick={onLoginButtonClick}>
                    {loc("pages.login.signInBtn")}
                </button>
            </div>
        </div>
    );
};

export default withLocalization(LoginPage);
